<div class="vtr-ui-switch-row"
	[ngClass]="{
		'white-theme': theme === WHITE_THEME,
		'blue-theme': theme === BLUE_THEME,
		'dark-theme': theme === DARK_THEME,
		'last-child': isLastChild
	}">
	<div class="container-fluid p-0"
		[ngClass]="{'vtr-disabled': disabled}">
		<div class="row m-0 d-flex justify-content-between position-relative">
			<div class="p-0"
				[ngClass]="{'flex-grow-1': (isSwitchVisible && !resetTextAsButton),
					'col-md-11 col-11':(!resetTextAsButton && !isSwitchVisible),
					'col-md-7': (resetTextAsButton && !isSwitchVisible),
					'col-md-10':type===undefined }">
				<div class="container-fluid p-0">
					<div class="row m-0">
						<div class="col-auto left-icon-column"
							*ngIf="leftIcon.length > 0">
							<div class="left-icon-block"
								role="img"
								attr.aria-label="{{title}}">
								<fa-icon *ngIf="!isAdminRequired && leftIcon[0]!=='icomoon' && leftIcon[0]!=='svg'"
									class="left-icon"
									[icon]="leftIcon"
									aria-hidden="true"></fa-icon>
								<svg-icon *ngIf="!isAdminRequired && leftIcon[0]==='svg'"
									attr.aria-hidden="true"
									[applyCss]="true"
									[stretch]="true"
									class="left-icon-svg svg-inline--fa fa-w-20  ng-fa-icon"
									[src]="'assets/icons/'+leftIcon[1]+'.svg'"></svg-icon>
								<span *ngIf="!isAdminRequired && leftIcon[0]==='icomoon'"
									[ngClass]="'icomoon '+leftIcon[1]"
									aria-hidden="true"></span>
								<img *ngIf="isAdminRequired"
									aria-hidden="true"
									class="adminLogo" />
							</div>
						</div>
						<div class="col">
							<h4 class="title"
								*ngIf="headingLevel!==5 && headingLevel!==-1"
								id="{{switchId}}-title">
								{{ title }}
							</h4>
							<h5 class="sub-title sub-title-h5"
								*ngIf="headingLevel===5"
								id="{{switchId}}-title">
								{{ title }}
							</h5>
							<p class="sub-title"
								role="text"
								*ngIf="headingLevel===-1"
								id="{{switchId}}-title">
								{{ title }}
							</p>
							<span *ngIf="caption">
								<p class="caption"
									role="text"
									#captionRef
									id="{{switchId}}-caption"
									[innerHTML]="caption.length > 70  && !contentExpand  && readMoreText.length > 0 ? (caption | slice: 0:70) : caption">
								</p>
							</span>
							<span id="{{'read_more_'+ switchId}}"
								*ngIf="readMoreText && !contentExpand"
								tabindex="0"
								role="link"
								class="read-more"
								(click)="onReadMoreClick($event)"
								[attr.aria-label]="'read more about,'+ title"
								(keydown.enter)="onReadMoreClick($event)">
								{{ readMoreText }}
							</span>
						</div>
					</div>
				</div>
			</div>

			<div [class]="'vtr-row-switch '+ uiSwitchClass()">
				<div class="p-0 mb-3"
					[ngClass]="{'ml-auto': type!=='Camera'}"
					*ngIf="resetText.length > 0">
					<vtr-material-button
						[linkId]="switchId + '-reset-btn'"
						[isDisabled]="disabledAll"
						(buttonClick)="onResetClick($event)"
						[label]="resetText"
					></vtr-material-button>
				</div>
				
				<material-slide-toggle 
				*ngIf="isSwitchVisible"
				#toggle
				[id]="switchId"
				[sendMetrics]="isMetricsEnabled"
				[value]="isSwitchChecked"
				[ariaLabel]="title"
				[loading]="showLoaderState"
				[disabled]="disabled || isDisabled"
				(toggle)="onOnOffChange($event)">
				</material-slide-toggle>

				<div *ngIf="!isSwitchVisible && linkText"
					class="p-0 link-text">
					<a *ngIf="linkPath.startsWith('ms-settings:'); else elseBlock"
						tabindex="0"
						id="{{switchId+ '_click_link'}}"
						role="link"
						[attr.aria-label]="title + '_click_link'"
						href="javascript:void(0)"
						(click)="onLinkClick(linkPath)"
						(keydown.enter)="onLinkClick(linkPath)"
						class="link-text">
						{{linkText}}
					</a>
					<ng-template #elseBlock>
						<a routerLink="/{{linkPath}}"
							id="ui-row-switch-link-text"
							role="link"
							class="link-text">
							{{linkText}}
						</a>
					</ng-template>
				</div>
				<div class="tool-tip-icon float-right"
					*ngIf="rightIcon.length > 0 && !voice && !toolTipStatus && !fnCtrltoolTip"
					[ngClass]="{'auto-screen-lock-help-icon': !isSwitchVisible}">
					<fa-icon id="{{switchId}}-tooltip_right_icon"
						[attr.aria-label]="title +' tooltip, which reads: '+ removeHTMLFormatting(tooltipText)"
						class="right-icon"
						[tabindex]="disabled || isDisabled? -1: 0"
						[matPopupTriggerFor]="tooltipRef"
						role="img"
						[icon]="rightIcon"
						tooltipClass="vtr-tooltip"
						(keydown.enter)="onRightIconClick(rightToolTip1, $event)">
					</fa-icon>
				</div>
				<div class="tool-tip-icon float-right"
					[ngClass]="{'pl-4': type==='Camera'}"
					*ngIf="rightIcon.length > 0 && toolTipStatus">
					<fa-icon id="{{switchId+ '_smartTooltip_right_icon'}}"
						[tabindex]="disabled || isDisabled? -1: 0"
						[attr.aria-label]="title +' tooltip, which reads: '+ removeHTMLFormatting(tooltipText)"
						class="right-icon"
						role="img"
						[matPopupTriggerFor]="smartTooltipRef"
						[icon]="rightIcon">
					</fa-icon>
				</div>

				<div class="tool-tip-icon float-right"
					[ngClass]="{'pl-4': type==='Camera'}"
					*ngIf="rightIcon.length > 0 && fnCtrltoolTip">
					<fa-icon id="{{switchId+ '_fnCtrl_right_icon'}}"
						[tabindex]="disabled || isDisabled? -1: 0"
						[attr.aria-label]="title +' tooltip, which reads: '+ removeHTMLFormatting(tooltipText)"
						class="right-icon"
						role="img"
						[matPopupTriggerFor]="fnCtrltoolTipRef"
						[icon]="rightIcon"></fa-icon>
				</div>

				<div class="tool-tip-icon float-right"
					*ngIf="rightIcon.length > 0 && voice">
					<fa-icon id="{{switchId+ '_voice_right_icon'}}"
						[attr.aria-label]="title +' tooltip, which reads: '+ removeHTMLFormatting(tooltipText)"
						class="right-icon"
						[tabindex]="disabled || isDisabled? -1: 0"
						[icon]="rightIcon"
						(click)="voicePopUp()"
						(keydown.enter)="voicePopUp()"></fa-icon>
				</div>
			</div>
		</div>
		<div class="row m-0"
			[ngClass]="{'pl-5': leftIcon.length > 0}"
			*ngIf="showChildContent">
			<div class="col-12 p-0">
				<ng-content #childContent></ng-content>
			</div>
		</div>
	</div>
	<hr *ngIf="!isLastChild" class="col card-body-hr" aria-hidden="true"/>
</div>

<mat-menu #tooltipRef [hasBackdrop]="false" class="vtr-tooltip" xPosition="before" yPosition="center">
	<div mat-menu-item id="{{switchId}}-toolTip" [innerHtml]="tooltipText">
	</div>
</mat-menu>

<!-- Intelligent-security distance sensitivity adjusting tooltip content -->
<mat-menu #smartTooltipRef [hasBackdrop]="false" class="vtr-tooltip" xPosition="before" yPosition="center">
	<div>
		{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.context1' | translate}}
	</div>
	<ul class="smart-tooltip-list">
		<li>
			<div class="row">
				<div class="col-auto pl-0 custom-padding">
					<fa-icon [icon]="['fas', 'circle']"></fa-icon>
				</div>
				<div class="col">
					{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.list.line1' | translate}}
				</div>
			</div>
		</li>
		<li>
			<div class="row">
				<div class="col-auto pl-0 custom-padding">
					<fa-icon [icon]="['fas', 'circle']"></fa-icon>
				</div>
				<div class="col">
					{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.list.line2' | translate}}
				</div>
			</div>
		</li>
		<li>
			<div class="row">
				<div class="col-auto pl-0 custom-padding">
					<fa-icon [icon]="['fas', 'circle']"></fa-icon>
				</div>
				<div class="col">
					{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.list.line3' | translate}}
				</div>
			</div>
		</li>
	</ul>
	<div>
		{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.context2' | translate}}
	</div>
	<ul class="smart-tooltip-list">
		<li>
			<div class="row">
				<div class="col-auto pl-0 custom-padding">
					<fa-icon [icon]="['fas', 'circle']"></fa-icon>
				</div>
				<div class="col">
					{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.list.line4' | translate}}
				</div>
			</div>
		</li>
		<li>
			<div class="row">
				<div class="col-auto pl-0 custom-padding">
					<fa-icon [icon]="['fas', 'circle']"></fa-icon>
				</div>
				<div class="col">
					{{'device.smartAssist.intelligentSecurity.distanceSensitivityAdjusting.tooltipcontent.list.line5' | translate}}
				</div>
			</div>
		</li>
	</ul>
</mat-menu>

<!-- Fn Ctrl tooltip content -->
<mat-menu #fnCtrltoolTipRef [hasBackdrop]="false" class="vtr-tooltip" xPosition="before" yPosition="center">
	<table class="table table-bordered">
		<thead>
			<tr>
				<th>{{ "device.deviceSettings.inputAccessories.fnCtrlKey.tootTip.fnKeys.heading" | translate}}</th>
				<th>{{ "device.deviceSettings.inputAccessories.fnCtrlKey.tootTip.ctrlKeys.heading" | translate}}</th>
				<th>{{ "device.deviceSettings.inputAccessories.fnCtrlKey.tootTip.action.heading" | translate}}</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of tooltipContent">
				<td>{{item.fnkey | translate}}</td>
				<td>{{item.ctrlKey | translate}}</td>
				<td>{{item.action | translate}}</td>
			</tr>
		</tbody>
	</table>
</mat-menu>
